import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../navbar.css';

function Menu({
  targetPaths = [], // 메뉴가 표시될 경로들
  menuItems = [], // 메뉴 항목들 [{ path: '/path', label: 'Label' }]
  className = '', // 추가 CSS 클래스
  position = { top: '10px', left: '-220px' }, // 메뉴 위치
  width = '220px', // 메뉴 너비
  height = 'auto', // 항목 수에 맞춰 늘어난다. 고정 150px는 항목 3개부터 넘쳤다
  buttonStyle = {}
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const menuRef = useRef(null);
  const location = useLocation();
  const pathname = location.pathname;

  // targetPaths가 비어있거나 현재 경로가 포함되어 있으면 메뉴 표시
  const shouldShowMenu = targetPaths.length === 0 || targetPaths.includes(pathname);

  // 메뉴 외부 클릭 시 닫기
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsMenuOpen(false);
        setIsClicked(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleMouseLeave = () => {
    if (!isClicked) {
      setIsMenuOpen(false);
    }
  };

  const handleClick = () => {
    if (!isClicked) {
      setIsClicked(true);
      setIsMenuOpen(true);
    } else {
      setIsClicked(false);
      setIsMenuOpen(false);
    }
  };

  if (!shouldShowMenu) {
    return null;
  }

  return (
    <div ref={menuRef}>
      <div
        className={`navbar ${isMenuOpen ? 'open' : ''} ${className}`}
        onMouseLeave={handleMouseLeave}
        style={{
          top: position.top,
          left: isMenuOpen ? '0px' : position.left,
          width: width,
          height: height
        }}
      >
        <div 
          className="menu-button" 
          onClick={handleClick}
          onMouseEnter={() => setIsMenuOpen(true)}
          style={buttonStyle} 
        >
          <span style={{ cursor: 'pointer', margin: '0 7px' }}>
            {isClicked ? '⨉' : '☰'}
          </span>
        </div>
        <div className={`menu-items ${isMenuOpen ? 'open' : ''}`}>
          <ul>
            {menuItems.map((item, index) => (
              <li 
                key={index}
                className={pathname === item.path ? 'selected' : ''}
              >
                <Link to={item.path}>{item.label}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Menu;
